import { Link } from 'react-router-dom';

const ingredients = [
  ['西洋參', '補氣與精神支持'],
  ['九蒸九曬黃精', '滋養與體力支持'],
  ['肉桂', '代謝與循環支持'],
  ['苦瓜提取物', '醣類代謝支持'],
  ['99% 亞精胺', '細胞自噬研究亮點'],
  ['玉竹', '滋養與水分平衡'],
  ['茯苓', '脾胃與日常代謝支持'],
  ['桑葉', '醣脂代謝支持'],
  ['白扁豆', '健脾食養支持'],
  ['山楂', '脂質與消化支持'],
  ['麩炒山藥', '脾胃與醣代謝支持'],
  ['廣陳皮', '理氣與消化支持'],
  ['炒決明子', '脂質代謝與順暢支持'],
  ['玉米鬚', '水分代謝支持'],
];

function SmartImage({ src, alt, className = '' }: { src: string; alt: string; className?: string }) {
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      loading="lazy"
      onError={(event) => {
        event.currentTarget.style.display = 'none';
      }}
    />
  );
}

export default function SugarAwayV4Page() {
  return (
    <main className="w-full bg-[#fbfaf6] text-stone-900">
      <section className="relative overflow-hidden bg-[#17351f] px-4 py-16 md:px-8 md:py-24">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_15%_15%,rgba(255,255,255,.12),transparent_32%),radial-gradient(circle_at_85%_70%,rgba(214,170,76,.18),transparent_30%)]" />
        <div className="relative mx-auto grid max-w-6xl gap-10 lg:grid-cols-[1.05fr_.95fr] lg:items-center">
          <div>
            <span className="inline-flex rounded-full border border-white/20 bg-white/10 px-3 py-1 text-xs font-semibold tracking-wide text-white/90">快草堂 QUICK HERBS · 原料透明與製程證據頁</span>
            <h1 className="mt-5 font-heading text-4xl font-bold leading-tight text-white md:text-6xl">醣溜溜 V4.8</h1>
            <p className="mt-4 max-w-2xl text-lg leading-8 text-white/75 md:text-xl">14 種植物與機能性原料複方，從醣脂代謝、脾胃食養、肝腎支持到細胞自噬研究，重新建立一套可追溯、可檢驗、可閱讀的產品知識頁。</p>
            <div className="mt-7 flex flex-wrap gap-2 text-sm text-white/90">
              {['14 種核心原料', '九蒸九曬黃精', '99% 高純度亞精胺', '電子束製程', '成品與原料檢測'].map((item) => (
                <span key={item} className="rounded-full border border-white/15 bg-white/10 px-3 py-1.5">{item}</span>
              ))}
            </div>
          </div>
          <div className="overflow-hidden rounded-[2rem] border border-white/15 bg-white/5 shadow-2xl">
            <SmartImage src="/assets/sugaraway-v4/hero.webp" alt="醣溜溜 V4 品牌主視覺" className="aspect-square w-full object-cover" />
            <div className="p-6 text-white">
              <p className="text-xs font-semibold uppercase tracking-[.2em] text-amber-300">V4.8 PRODUCT STORY</p>
              <p className="mt-2 text-sm leading-6 text-white/70">本頁以配方、原料、製程與檢測資料為主軸，不以疾病治療宣稱作為產品定位。</p>
            </div>
          </div>
        </div>
      </section>

      <section className="px-4 py-12 md:px-8">
        <div className="mx-auto max-w-5xl rounded-3xl border border-amber-200 bg-amber-50 p-6 md:p-8">
          <h2 className="font-heading text-2xl font-bold">先說清楚：這是一個食養產品知識頁</h2>
          <p className="mt-3 leading-7 text-stone-700">醣溜溜屬一般食品／食養型產品。本頁介紹配方理念、原料資料、製程與送驗結果，不應解讀為疾病治療、替代藥物或保證療效。糖尿病、高血壓、高血脂及肝腎疾病患者若正在用藥，任何藥物調整都應由醫師依檢驗數據決定。</p>
        </div>
      </section>

      <section className="bg-white px-4 py-14 md:px-8">
        <div className="mx-auto max-w-6xl">
          <div className="max-w-3xl">
            <span className="text-sm font-semibold text-emerald-700">V3 → V4.8</span>
            <h2 className="mt-2 font-heading text-3xl font-bold md:text-4xl">從配方升級，到原料與製程升級</h2>
            <p className="mt-4 leading-7 text-stone-600">V4.8 不只是改配方，也把黃精炮製、低溫乾燥、原料驗收、電子束處理與成品檢測一起納入品質系統。</p>
          </div>
          <div className="mt-8 grid gap-5 md:grid-cols-2">
            <figure className="overflow-hidden rounded-3xl border border-stone-200 bg-stone-50">
              <SmartImage src="/assets/sugaraway-v4/v3-v4-bottles.webp" alt="V3 與 V4 瓶身比較" className="w-full object-cover" />
              <figcaption className="p-5"><strong>瓶身版本比較</strong><p className="mt-1 text-sm text-stone-500">左為 V3，右為 V4。</p></figcaption>
            </figure>
            <figure className="overflow-hidden rounded-3xl border border-stone-200 bg-stone-50">
              <SmartImage src="/assets/sugaraway-v4/v3-v4-tablets.webp" alt="V3 與 V4 錠劑外觀比較" className="w-full object-cover" />
              <figcaption className="p-5"><strong>錠劑外觀比較</strong><p className="mt-1 text-sm text-stone-500">實物可見 V3 與 V4 顏色與粉體質感差異。</p></figcaption>
            </figure>
          </div>
          <div className="mt-6 grid gap-4 md:grid-cols-4">
            {[
              ['九蒸九曬黃精', '炮製後高度黏稠，再以低溫冷凍乾燥協助粉體化。'],
              ['低溫乾燥', '降低長時間高溫處理對熱敏感成分造成的損耗。'],
              ['電子束處理', '採電子束輻照，不以「完全不破壞成分」作宣稱。'],
              ['多重檢驗', '成品與部分原料以農殘、重金屬、微生物等項目驗證。'],
            ].map(([title, text]) => (
              <div key={title} className="rounded-2xl border border-stone-200 bg-[#fbfaf6] p-5"><h3 className="font-bold text-emerald-900">{title}</h3><p className="mt-2 text-sm leading-6 text-stone-600">{text}</p></div>
            ))}
          </div>
        </div>
      </section>

      <section className="px-4 py-14 md:px-8">
        <div className="mx-auto max-w-6xl">
          <div className="grid gap-8 lg:grid-cols-[1fr_.85fr] lg:items-start">
            <div>
              <span className="text-sm font-semibold text-emerald-700">V4.8 真實配方</span>
              <h2 className="mt-2 font-heading text-3xl font-bold md:text-4xl">14 項核心成分，一項一項公開</h2>
              <p className="mt-4 max-w-3xl leading-7 text-stone-600">我們不只列出名稱，後續會逐項補上來源、實拍影片、COA／檢驗摘要與原始證據。山楂先作為第一個完整樣板。</p>
              <div className="mt-7 grid gap-3 sm:grid-cols-2">
                {ingredients.map(([name, role], index) => (
                  <div key={name} className="flex gap-3 rounded-2xl border border-stone-200 bg-white p-4 shadow-sm">
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-emerald-50 text-xs font-bold text-emerald-800">{index + 1}</span>
                    <div><h3 className="font-semibold">{name}</h3><p className="mt-1 text-xs leading-5 text-stone-500">{role}</p></div>
                  </div>
                ))}
              </div>
            </div>
            <figure className="overflow-hidden rounded-3xl border border-stone-200 bg-white shadow-sm">
              <SmartImage src="/assets/sugaraway-v4/ingredients.webp" alt="醣溜溜 V4.8 成分表" className="w-full object-contain" />
              <figcaption className="p-5 text-sm leading-6 text-stone-500">V4.8 實際成分表。網站中的成分名稱與排序，以此表及正式產品資料為依據。</figcaption>
            </figure>
          </div>
        </div>
      </section>

      <section className="bg-[#17351f] px-4 py-16 text-white md:px-8">
        <div className="mx-auto max-w-6xl">
          <div className="grid gap-8 lg:grid-cols-[.85fr_1.15fr] lg:items-center">
            <figure className="overflow-hidden rounded-3xl border border-white/10 bg-white p-3">
              <SmartImage src="/assets/sugaraway-v4/ebeam-certificate.webp" alt="電子束輻照證明" className="w-full rounded-2xl object-contain" />
            </figure>
            <div>
              <span className="text-sm font-semibold text-amber-300">製程證據</span>
              <h2 className="mt-2 font-heading text-3xl font-bold md:text-4xl">V4 採電子束輻照處理</h2>
              <p className="mt-4 leading-7 text-white/70">你提供的輻照證明顯示，多項植物原料依國家標準或契約約定，以電子束射線進行處理。電子束與使用鈷-60 放射源的 γ 射線並不是同一種設備路徑。</p>
              <div className="mt-5 rounded-2xl border border-amber-300/20 bg-amber-300/10 p-5 text-sm leading-6 text-amber-50">對外不使用「完全不破壞成分」這種絕對說法。較嚴謹的表述是：在適當劑量與製程控制下，可避免傳統高溫滅菌帶來的熱負荷，對保留熱敏感成分更有利。</div>
            </div>
          </div>
        </div>
      </section>

      <section className="px-4 py-16 md:px-8" id="hawthorn-evidence">
        <div className="mx-auto max-w-6xl">
          <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
            <div>
              <span className="text-sm font-semibold text-emerald-700">核心原料證據模組 · SAMPLE 01</span>
              <h2 className="mt-2 font-heading text-3xl font-bold md:text-4xl">山楂｜從原料影像到第三方檢驗</h2>
            </div>
            <span className="w-fit rounded-full bg-emerald-50 px-3 py-1.5 text-xs font-semibold text-emerald-800">14 項原料透明工程的第一個樣板</span>
          </div>

          <div className="mt-8 grid gap-6 lg:grid-cols-[.9fr_1.1fr]">
            <div className="overflow-hidden rounded-3xl border border-stone-200 bg-black shadow-sm">
              <div className="relative aspect-[9/16] max-h-[680px] w-full bg-black">
                <img src="/assets/sugaraway-v4/hawthorn-poster.webp" alt="山楂原料影片封面" className="absolute inset-0 h-full w-full object-contain" />
                <video
                  className="relative z-10 h-full w-full bg-black object-contain"
                  controls
                  playsInline
                  preload="metadata"
                  poster="/assets/sugaraway-v4/hawthorn-poster.webp"
                  onError={(event) => {
                    event.currentTarget.style.display = 'none';
                  }}
                >
                  <source src="/assets/sugaraway-v4/hawthorn.mp4" type="video/mp4" />
                </video>
              </div>
              <div className="bg-white p-5">
                <h3 className="font-bold">山楂原料實拍</h3>
                <p className="mt-1 text-sm leading-6 text-stone-500">影片可正常載入時直接播放；若原始 MP4 尚未同步，頁面會自動保留封面，不會出現破圖或空白播放器。</p>
              </div>
            </div>

            <div className="space-y-5">
              <div className="rounded-3xl border border-stone-200 bg-white p-6 shadow-sm md:p-8">
                <div className="flex flex-wrap items-center justify-between gap-3"><h3 className="font-heading text-2xl font-bold">第三方檢測摘要</h3><span className="rounded-full bg-stone-100 px-3 py-1 text-xs text-stone-600">報告編號 NTC202505111940</span></div>
                <p className="mt-4 text-sm leading-6 text-stone-600">檢測機構：英格爾檢測認證（山東）有限公司。樣品名稱：山楂。報告結論為所檢項目（不包括無判定依據項目）符合 GB 2763-2021 要求。</p>
                <div className="mt-6 grid gap-3 sm:grid-cols-2">
                  {[
                    ['鉛 Pb', '未檢出（<0.04 mg/kg）'],
                    ['總砷 As', '未檢出（<0.04 mg/kg）'],
                    ['總汞 Hg', '未檢出（<0.01 mg/kg）'],
                    ['鎘 Cd', '未檢出（<0.004 mg/kg）'],
                    ['農藥項目', '多項未檢出'],
                    ['總檢測項目', '37 項'],
                  ].map(([label, value]) => (
                    <div key={label} className="rounded-2xl bg-[#fbfaf6] p-4"><div className="text-xs font-semibold uppercase tracking-wide text-stone-400">{label}</div><div className="mt-1 font-bold text-emerald-900">{value}</div></div>
                  ))}
                </div>
                <a
                  href="/assets/sugaraway-v4/hawthorn-coa.pdf"
                  target="_blank"
                  rel="noreferrer"
                  className="mt-6 inline-flex rounded-full bg-emerald-900 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-emerald-800"
                >
                  查看山楂原始 COA 報告
                </a>
                <p className="mt-5 text-xs leading-5 text-stone-400">注意：委託送樣檢驗結果僅代表該送驗樣品；原檢測報告亦載明不得用於不當宣傳。因此網站只做原料透明與檢測資訊揭露，不將 COA 解讀為療效證明。</p>
              </div>

              <div className="rounded-3xl border border-emerald-200 bg-emerald-50 p-6 md:p-8">
                <h3 className="font-heading text-xl font-bold text-emerald-950">山楂在 V4.8 配方中的角色</h3>
                <p className="mt-3 leading-7 text-emerald-950/70">山楂在配方中定位於脂質代謝、消化與整體代謝協同。對外介紹以傳統食養用途與現代成分研究方向為主，不直接宣稱治療高血脂、脂肪肝或血管疾病。</p>
              </div>

              <div className="rounded-3xl border border-dashed border-stone-300 bg-stone-50 p-6 md:p-8">
                <h3 className="font-heading text-xl font-bold">其餘 13 種原料將沿用同一格式</h3>
                <p className="mt-3 text-sm leading-6 text-stone-600">每一項依序補齊：原料名稱與角色、實拍影片或圖片、COA／第三方檢測摘要、原始文件入口，以及必要的檢驗限制說明。這樣整個頁面會維持一致閱讀邏輯，不會變成零散資料堆疊。</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white px-4 py-16 md:px-8">
        <div className="mx-auto max-w-5xl">
          <h2 className="font-heading text-3xl font-bold">成品品質檢測</h2>
          <p className="mt-3 leading-7 text-stone-600">2026 年 6 月送交台美檢驗科技的醣溜溜食療片檢體，完成農藥殘留、黃麴毒素、重金屬與微生物等項目檢驗。結果僅代表該次送驗檢體。</p>
          <div className="mt-7 grid gap-3 sm:grid-cols-2">
            {[
              '農藥殘留 411 項：未檢出',
              '黃麴毒素 B1、B2、G1、G2 與總量：未檢出',
              '砷、鎘、汞：未檢出；鉛 2.2 ppm',
              '大腸桿菌、沙門氏桿菌、金黃色葡萄球菌：陰性',
              '黴菌及酵母菌：陰性',
              '生菌數：8.0×10³ CFU/g',
            ].map((item) => <div key={item} className="rounded-2xl border border-stone-200 bg-[#fbfaf6] p-4 text-sm leading-6 text-stone-700">✓ {item}</div>)}
          </div>
          <p className="mt-5 text-xs leading-5 text-stone-400">資料來源：台美檢驗科技股份有限公司，報告編號 M61-260601587，報告日期 2026/06/29。</p>
        </div>
      </section>

      <section className="bg-stone-950 px-4 py-16 text-white md:px-8">
        <div className="mx-auto max-w-5xl text-center">
          <p className="text-sm font-semibold text-amber-300">醣溜溜 V4.8</p>
          <h2 className="mx-auto mt-3 max-w-3xl font-heading text-3xl font-bold leading-tight md:text-4xl">不是只看一個血糖數字，而是把配方、原料、製程與證據放在同一張圖上。</h2>
          <p className="mx-auto mt-5 max-w-3xl text-sm leading-7 text-white/60">後續其餘 13 種原料將沿用山楂相同的證據模組，逐項補上原料影片、COA 摘要與來源資訊。</p>
          <Link to="/" className="mt-8 inline-flex rounded-full bg-white px-5 py-2.5 text-sm font-semibold text-stone-900 transition hover:bg-stone-100">返回 88 健康知識首頁</Link>
        </div>
      </section>
    </main>
  );
}
